import React, {
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react';
import PropTypes from 'prop-types';
import ModalBootstrap from 'react-bootstrap/Modal';

export const ModalSize = {
  LARGE: 'lg',
  SMALL: 'sm',
  XLARGE:'xl',
  '': '',
};

const Modal = forwardRef((props, ref) => {
  const {
    title,
    children,
    onClose,
    size,
    dialogClassName
  } = props;

  const [show, setShow] = useState(true);

  const handleClose = () => {
    onClose();
    setShow(false);
  };

  useImperativeHandle(ref, () => ({
    close() {
      handleClose();
    },
  }));

  const body = children.length > 0 && typeof children !== 'string' ? children[0] : children;
  const footer = children.length > 0 && typeof children !== 'string' ? children[1] : undefined;

  return (
    <ModalBootstrap size={size} show={show} onHide={handleClose} dialogClassName={dialogClassName}>
      <ModalBootstrap.Header closeButton>
        <ModalBootstrap.Title>{title}</ModalBootstrap.Title>
      </ModalBootstrap.Header>
      <ModalBootstrap.Body>{body}</ModalBootstrap.Body>
      { footer && (
        <ModalBootstrap.Footer>{footer}</ModalBootstrap.Footer>
      )}
    </ModalBootstrap>
  );
});

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onClose: PropTypes.func,
  size: PropTypes.oneOf(Object.values(ModalSize)),
  dialogClassName: PropTypes.string,
};

Modal.defaultProps = {
  onClose: () => {},
  size: '',
  dialogClassName: '',
};

export default Modal;
